// extracted by mini-css-extract-plugin
export default {"root":"NtBDdE","postPublishDate":"wBTynn","authorLink":"IkAhjA","authorName":"MABqta","authorImageWrapper":"bZrSjY","authorAvatar":"bok7Ik","postReadingTime":"F56Ope"};